import styled from "styled-components";
import Column from "./Column";
const HalfColumn = styled(Column)`
  width: 50%;
`;
export default HalfColumn;
